document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-el-relief]');

  if (!sections.length) return;

  sections.forEach((section) => {
    const triggers = section.querySelectorAll('[data-el-relief-tab-trigger]');
    const panels = section.querySelectorAll('[data-el-relief-tab-panel]');

    if (!triggers.length || !panels.length) return;

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const target = trigger.getAttribute('data-tab-target');

        triggers.forEach((t) => t.classList.remove('is-active'));
        panels.forEach((p) => p.classList.remove('is-active'));

        trigger.classList.add('is-active');

        const activePanel = section.querySelector(
          `[data-tab-panel="${target}"]`
        );

        if (activePanel) {
          activePanel.classList.add('is-active');
        }
      });
    });
  });
});